var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEth = function SvgIconEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.996 0-.201.684v19.838l.201.2 9.209-5.443L9.996 0Z",
    fill: "#214A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.998 0 .79 15.28l9.208 5.442V0Z",
    fill: "#5894AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.996 22.464-.113.139v7.066l.113.331 9.214-12.976-9.214 5.44Z",
    fill: "#375F8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.998 30v-7.536L.79 17.024 9.998 30Z",
    fill: "#5894AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.997 20.72 9.209-5.444-9.209-4.186v9.63Z",
    fill: "#1B3752"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m.79 15.276 9.208 5.443V11.09L.79 15.276Z",
    fill: "#375F8D"
  })));
};

export default SvgIconEth;